import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LandingPage.css';

const games = [
  {
    title: 'Idea Match',
    text: 'Match startup ideas to customer pain points and strengthen your founder thinking.',
    path: '/games/idea-match',
  },
  {
    title: 'Pricing Challenge',
    text: 'Practice practical pricing using cost, margin, and confidence in each round.',
    path: '/games/pricing-challenge',
  },
  {
    title: 'Budget Builder',
    text: 'Build a startup monthly budget and keep your growth runway under control.',
    path: '/games/budget-builder',
  },
];

const modules = [
  'Business Ideas & Validation',
  'Marketing and Sales',
  'Financial Literacy',
  'Business Strategy',
];

const LandingPage = () => {
  return (
    <div className="landing-shell">
      <header className="topbar">
        <div className="container topbar-inner">
          <div className="brand">EntrepreLearn</div>
          <nav className="nav-links">
            <Link to="/games">Games</Link>
            <Link to="/modules">Modules</Link>
            <Link to="/about">About</Link>
          </nav>
          <Link className="btn btn-outline" to="/games">Get Started</Link>
        </div>
      </header>

      <main>
        <section className="hero" id="start">
          <div className="container hero-grid">
            <div>
              <p className="eyebrow">Fun Entrepreneurship Learning</p>
              <h1>Learn entrepreneurship in a fun and engaging way.</h1>
              <p className="hero-text">
                EntrepreLearn blends games, mini-lessons, and practical challenges so students can build
                entrepreneurial skills by doing, not just reading.
              </p>
              <div className="hero-actions">
                <Link className="btn btn-solid" to="/modules">Explore Modules</Link>
                <Link className="btn btn-light" to="/games">Play a Game</Link>
              </div>
            </div>
            <div className="hero-card">
              <h3>What You Build Here</h3>
              <ul>
                <li>Creative problem-solving</li>
                <li>Business thinking</li>
                <li>Money confidence</li>
                <li>Startup communication skills</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section" id="games">
          <div className="container">
            <h2>Game-Based Learning</h2>
            <p className="section-text">Short, repeatable game sessions designed for skill retention and confidence.</p>
            <div className="card-grid">
              {games.map((game) => (
                <article className="card" key={game.title}>
                  <h3>{game.title}</h3>
                  <p>{game.text}</p>
                  <Link className="btn btn-light" to={game.path}>Play Now</Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-alt" id="modules">
          <div className="container">
            <h2>Learning Modules</h2>
            <div className="module-list">
              {modules.map((module) => (
                <div className="module-item" key={module}>{module}</div>
              ))}
            </div>
            <div className="hero-actions">
              <Link className="btn btn-solid" to="/modules">Open All Modules</Link>
            </div>
          </div>
        </section>

        <section className="section" id="how">
          <div className="container how-grid">
            <div>
              <h2>How It Works</h2>
              <p className="section-text">Pick a topic, complete a lesson, and reinforce it with a game challenge.</p>
            </div>
            <ol className="steps">
              <li>Choose a module</li>
              <li>Learn the concept</li>
              <li>Play a related game</li>
              <li>Track your growth</li>
            </ol>
            <div className="hero-actions">
              <Link className="btn btn-solid" to="/about">Learn About EntrepreLearn</Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer-inner">
          <p>2026 EntrepreLearn</p>
          <p>Learn. Play. Build.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;